module.exports = __webpack_public_path__ + "img/11Stapel200miljonerton.cfa07c77.png";